// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useTeamSurvivorEntryDisplayStyles = createStyles(
  (theme, params: { width: number }, getRef) => ({
    slate: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.other.spacing._4,
      alignItems: 'center',
      color: theme.colors.gray2[3],
      width: params.width,

      '&.isSlateMissingPicks': {
        color: theme.colors.orange[3],

        [`& .${getRef('slatePicks')}`]: {
          borderColor: theme.colors.orange[3],
        },
      },

      '&.isInteractive': {
        '@media (hover: hover)': {
          transition: 'opacity 150ms ease-in-out',

          '&:hover': {
            opacity: 0.5,
          },
        },
      },
    },
    slateLabel: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
      overflow: 'hidden',
    },
    slatePicks: {
      ref: getRef('slatePicks'),
      height: 80,
      minWidth: 80,
      border: `1px solid ${theme.colors.gray2[1]}`,
      borderRadius: theme.other.spacing._8,
      display: 'flex',
      padding: `${theme.other.spacing._8}px ${theme.other.spacing._16}px`,
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.other.spacing._8,
      width: params.width,

      // Win/Loss styling - matching the existing leaderboard system
      '&.isWin': {
        background: theme.colors.green[2],
        borderColor: theme.colors.green[5],
      },
      '&.isLoss': {
        background: theme.colors.red[2],
        borderColor: theme.colors.red[5],
      },
      // In-progress win/loss styling for single-game slates
      '&.isWinning': {
        borderColor: theme.colors.green[4],
      },
      '&.isLosing': {
        borderColor: theme.colors.red[4],
      },
    },
  })
);

export const useTeamPickIconDisplayStyles = createStyles((theme) => ({
  makePick: {
    textAlign: 'center',
  },
  slatePick: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  pickImage: {
    width: 48,
    height: 48,
    position: 'relative',

    '& img': {
      objectFit: 'contain',
    },
  },
  pickName: {
    color: theme.colors.gray2[7],
    width: 48,
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  pickSpread: {
    color: theme.colors.gray2[4],
    textAlign: 'center',
  },
}));
